import "./MissionVision.css";

const coreValues = [
  {
    title: "Quality Excellence",
    description:
      "We source the highest standards in paper and film products, ensuring durability, precision, and performance that meet the evolving needs of our customers.",
  },
  {
    title: "Reliability & Service",
    description:
      "Dependable delivery and responsive support are at the heart of our operations. We strive to be a trusted partner who consistently delivers on promises.",
  },
  {
    title: "Competitive Value",
    description:
      "We balance premium quality with fair, competitive pricing providing solutions that maximize value without compromise.",
  },
  {
    title: "Partnership & Trust",
    description:
      "We believe in cultivating long-term relationships with customers and suppliers, built on transparency, respect, and shared success.",
  },
  {
    title: "Innovation & Sustainability",
    description:
      "We embrace innovation in product development and operational practices, while committing to sustainable solutions that protect our environment and future generations.",
  },
];

const visionPoints = [
  {
    title: "Set Industry Standards",
    description:
      "Lead the market by consistently delivering products that exceed expectations in performance, durability, and value.",
  },
  {
    title: "Champion Sustainability",
    description:
      "Innovate responsibly, integrating eco-friendly practices and materials that safeguard the environment for future generations.",
  },
  {
    title: "Empower Partnerships",
    description:
      "Build long-term, collaborative relationships with customers and suppliers, rooted in transparency, trust, and shared success.",
  },
  {
    title: "Drive Innovation",
    description:
      "Continuously evolve our product offerings and processes to meet the dynamic needs of industries and communities worldwide.",
  },
  {
    title: "Deliver Global Impact",
    description:
      "Expand our reach while maintaining local responsiveness, ensuring that every client experience dependable service and tailored solutions.",
  },
];

export default function MissionVision() {
  return (
    <section className="mission-section">
      <div className="mission-card">
        <img src="/mission.jpeg" alt="Our Mission" className="mission-image" />

        <h3>Our Mission</h3>

        <p>
          At RelyOnne UK Limited, our mission is to deliver high-quality paper
          and film products with reliable service, competitive pricing, and
          dependable delivery. We are dedicated to building long-term
          partnerships with our customers and suppliers, ensuring trust,
          consistency, and mutual growth.
        </p>

        <h4>Core Values</h4>
        <ul>
          {coreValues.map((value, index) => (
            <li key={value.title}>
              <strong>
                {index + 1}. {value.title}
              </strong>{" "}
              {value.description}
            </li>
          ))}
        </ul>
      </div>

      <div className="mission-card">
        <img src="/vision.jpeg" alt="Our Vision" className="mission-image" />

        <h3>Our Vision</h3>

        <p>
          We envision becoming the trusted global leader in paper and film
          solutions—recognized not only for uncompromising quality and
          reliability, but also for our commitment to innovation,
          sustainability, and enduring partnerships.
        </p>

        <ul>
          {visionPoints.map((point) => (
            <li key={point.title}>
              <strong>{point.title}:</strong> {point.description}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}